export function TestError() {
    throw new Error('TestError');

    return (
        <div>
            <h1>TestError</h1>
        </div>
    );
}
